import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MoonLoader from "react-spinners/MoonLoader";
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, LabelList } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from 'recharts';
import { LineChart, Line } from 'recharts';
import { NavLink, Outlet } from 'react-router-dom';
import { BsList } from 'react-icons/bs';
import './Admindashboard.css'
import { AiOutlinePieChart, AiOutlineLineChart, AiOutlineBarChart, AiOutlineUser } from 'react-icons/ai'

const COLORS = ['#f78716', '#012951'];  //absent , present

function AdminDashboard({ IP, TOKEN }) {

    // const datadata = [
    //     {
    //         name: 'Week 1',
    //         ElitePer: 89,
    //         FSA1Per: 90,
    //         FSA2Per: 60,
    //         FSB1Per: 80,
    //         FSB2Per: 90,
    //         FSB3Per: 50,
    //     },
    //     {
    //         name: 'Week 2',
    //         ElitePer: 70,
    //         FSA1Per: 50,
    //         FSA2Per: 80,
    //         FSB1Per: 90,
    //         FSB2Per: 30,
    //         FSB3Per: 50,
    //     },
    //     {
    //         name: 'Week 3',
    //         Elite: {
    //             per: 89
    //         },
    //         FSA1: {
    //             per: 90
    //         },
    //         FSA2: {
    //             per: 60
    //         },
    //         FSB1: {
    //             per: 80
    //         },
    //         FSB2: {
    //             per: 90
    //         },
    //         FSB3: {
    //             per: 50
    //         }
    //     }
    // ]



    return (
        <div className='m-0 w-100 main-div'>
            <div
                className="offcanvas offcanvas-top h-100"
                tabIndex="-1"
                id="CollapsedContent"
                aria-labelledby="CollapsedContentLabel"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="CollapsedContentLabel"></h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="sidebar mt-2">
                        <li>
                            <NavLink to="day-wise">
                                <AiOutlinePieChart className='me-2 mb-1' />Daywise Attendance
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="last-7-sessions">
                                <AiOutlineBarChart className='me-2 mb-1' />Last 7 Sessions
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="overall-attendance">
                                <AiOutlineLineChart className='me-2 mb-1' />Overall Attendance
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="deliquents">
                                <AiOutlineUser className='me-2 mb-1' />Deliquents
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="row m-0 p-0">
                <div
                    className="sidebar-bg col-lg-2 col-md-3 navbar-expand-md p-0"
                // style={{ backgroundColor: '#0129517f' }}
                >
                    <div className="">
                        <a
                            data-bs-toggle="offcanvas"
                            className="navbar-toggler toggler"
                            href="#CollapsedContent"
                            role="button"
                            aria-controls="CollapsedContent"
                        >
                            <span className="icon">
                                <BsList />
                            </span>
                        </a>
                        <h6 className='mt-3 pb-1 ps-2'>Attendance</h6>
                        <ul className="sidebar m-0 p-0 d-md-inline d-none list">
                            <li>
                                <NavLink to="day-wise">
                                    <AiOutlinePieChart className='me-2 mb-1' />Daywise
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="last-7-sessions">
                                    <AiOutlineBarChart className='me-2 mb-1' />Last 7 Sessions
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="overall-attendance">
                                    <AiOutlineLineChart className='me-2 mb-1' />Overall
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="deliquents">
                                    <AiOutlineUser className='me-2 mb-1' />Deliquents
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row col-lg-10 col-md-9 m-0 ">
                    <div className="content-data">
                        <Outlet />
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AdminDashboard;